import TreeDataHandler from '../../tool/treeDataHandler';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Dropdown, Flex, Input, Modal, Spin, Tooltip } from 'antd';
import { SimpleTreeItemWrapper, SortableTree } from 'dnd-kit-sortable-tree';
import React from 'react';
import stylesDark from './DirectoryPlusDark.less';
import stylesLight from './DirectoryPlusLight.less';

//基础配置
const GetBaseConfig = (theme='dark')=>{
  let styles = theme==='light' ? stylesLight : stylesDark;

  return {
    maxLevel: 3, //最多允许几层
    childIndent: 24, //子项缩进
    couldDrag: true, //是否允许拖拽
    couldAddGroup: true, //是否允许新增分组
    couldAddItem: true, //是否允许新增项目
    couldEditGroup: true, //是否允许编辑分组
    couldEditItem: true, //是否允许编辑项目
    couldDeleteGroup: true, //是否允许删除分组
    couldDeleteItem: true, //是否允许删除项目
    showGroupNum: true, //目录显示子元素数量
    showEmptyMark: true, //目录为空时展示子元素数量
    showAddItem: false, // 是否允许子级新增项目
    couldCloneItem: false, // 是否允许子级克隆项目
    subTitle: '分组目录',
    groupName: '分组',
    itemName: '项目',
    editGroupName: '重命名',
    editItemName: '重命名',
    deleteGroupName: '删除',
    deleteItemName: '删除',
    addItemName: '新增',
    cloneItemName: '克隆',
    placeholderText: '请输入名称',
    hideArrow: true, //隐藏分组的展开箭头
    hideTitle: false, //隐藏头部
    hideItemAddBtn: false, //隐藏目录中的新增按钮，不管是否有新增权限(不影响顶部的新增按钮)
    addIcon: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/add.png')})`,
          filter: theme==='light'?"invert(100%)":"",
        }}
      />
    ), //新增的图标
    moreIcon: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/more.png')})`,
          filter: theme==='light'?"invert(100%)":"",
        }}
      />
    ), //更多的图标
    addGroupIcon: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/addGroup.png')})`,
        }}
      />
    ), //新增分组的图标
    addItemIcon: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/addItem.png')})`,
        }}
      />
    ), //新增项目的图标
    groupArrowExpanded: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/down.png')})`,
          filter: theme==='light'?"invert(100%)":"",
          backgroundSize: '120%',
        }}
      />
    ), //分组箭头展开
    groupArrowCollapsed: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/right.png')})`,
          filter: theme==='light'?"invert(100%)":"",
          backgroundSize: '120%',
        }}
      />
    ), //分组箭头收起
    groupLogoExpanded: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/groupIcon.png')})`,
          filter: theme==='light'?"invert(100%)":"",
          marginRight: '2px',
        }}
      />
    ), //分组logo展开
    groupLogoCollapsed: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/groupIcon.png')})`,
          filter: theme==='light'?"invert(100%)":"",
          marginRight: '2px',
        }}
      />
    ), //分组logo收起
    itemLogo: (
      <div
        className={styles.icon}
        style={{
          backgroundImage: `url(${require('../../images/directory/itemIcon.png')})`,
          filter: theme==='light'?"invert(100%)":"",
        }}
      />
    ), //项目logo
    itemLogoFn: undefined, // 自定义logo，return节点
    groupLogoFn: undefined, // 自定义分组logo，return节点
    renderItemName: null, //自定义项目名称的渲染
    renderGroupName: null, //自定义分组名称的渲染
    // 自定义操作按钮
    customRightActionBefore: null,
    customRightActionAfter: null,
    couldSelectGroup: true,  // 分组是否可以选中
  }
};

//字段映射
const FieldsConfig = {
  title: 'title',
  id: 'id',
  isGroup: 'isGroup', //1 分组 0文件
  children: 'children',
  url: 'url', // 分组图标
};

//对样式的修改
const GetCustomStyle = (theme='dark')=>{
  return {
    containerStyle: {}, //外层样式
    selectItemStyle: {
      background: theme==='light'?'#843CFF33':'#3D3E82FF',
    },
    usualItemStyle: {},
  }
};

export default class Directory extends React.PureComponent {
  constructor(props) {
    super(props);

    this.styles = props.theme==='light' ? stylesLight : stylesDark;

    //整合配置项
    this.config = Object.assign({}, GetBaseConfig(props.theme), this.props.staticConfig);

    this.fields = Object.assign({}, FieldsConfig, this.props.fieldsConfig);
    this.styleSet = Object.assign({}, GetCustomStyle(props.theme), this.props.customStyle);
    //记录反映射，返回数据时需要反处理
    this.fieldsReverse = {};
    Object.keys(this.fields).forEach((field) => {
      this.fieldsReverse[this.fields[field]] = field;
    });

    this.state = {
      treeData: [],
      expandKeys: props.defaultExpandedKeys || {}, //展开的节点key，设置为对象，方便增删的操作
      selectTreeNode: null, //已经选择的节点
      matchTxt: null, //模糊搜索关键词
      disableDragAndDrop: this?.config?.couldDrag,
      loading: false, //加载中
      upDate: 0, //控制强更
      hasGroup: 0, //是否存在分组，用于控制是否展示展开icon
    };

    this.treeDataFull = []; //记录最完整的数据，用于筛选恢复
    this.refresh = this.refreshTreeDataAction;
    this.setData = (data) => {
      this.setState(data);
    };
  }

  componentDidMount() {
    this.initTreeData();
  }

  //设置树数据
  setTreeDataWithLastStatus(newTreeData) {
    this.treeDataFull = newTreeData;

    //第一个分组
    let firstGroupItem = TreeDataHandler.searchTreeNodeByField(
      newTreeData,
      {
        field: 'isGroup',
        value: 1,
      },
      'children',
    );

    this.setState({
      treeData: newTreeData,
      hasGroup: !!firstGroupItem,
      upDate: this.state.upDate + 1,
    });
  }

  //初始化树结构
  async initTreeData() {
    this.setState({
      loading: true,
    });

    let treeData = await this.getCompleteTreeData();

    //如果有选择的值，则展开的键要算
    let selectTreeNode = null;
    let defaultExpandedKeys = {};

    console.log('this.props.selectConfig', this.props.selectConfig);
    if (this.props.selectConfig) {
      if (this.props.selectConfig.defaultSelectMatchRule) {
        //由外部传入自定义匹配初始选择项
        selectTreeNode = TreeDataHandler.searchTreeNodeByField(treeData, this.props.selectConfig.defaultSelectMatchRule, 'children');

        console.log('selectTreeNode', selectTreeNode);
      } else if (this.props.selectConfig.defaultSelect) {
        let idValue = this.props.selectConfig.defaultSelect[this.fields['id']];

        selectTreeNode = TreeDataHandler.searchTreeNodeByField(
          treeData,
          {
            field: 'id',
            value: idValue,
          },
          'children',
        );
      }
    } else if (this.props.initAutoSelect) {
      //默认选择一个项目
      selectTreeNode = TreeDataHandler.searchTreeNodeByField(
        treeData,
        {
          field: 'isGroup',
          value: 0,
        },
        'children',
      );

      if (!selectTreeNode) {
        //没有子集，选择分组
        selectTreeNode = TreeDataHandler.searchTreeNodeByField(
          treeData,
          {
            field: 'isGroup',
            value: 1,
          },
          'children',
        );
      }
    }
    let path;
    if (selectTreeNode) {
      path = TreeDataHandler.getNodeDeepPath(
        treeData,
        (o) => {
          return o['id'] === selectTreeNode.id;
        },
        'children',
      );

      if (path.length >= 0) {
        path.forEach((item) => {
          defaultExpandedKeys[item.id] = true;
        });
      }
    }

    //给设置扩展属性
    treeData = TreeDataHandler.recursionDeal(treeData, (item) => {
      //是否展开
      item.collapsed = !defaultExpandedKeys.hasOwnProperty(item.id);
      //是否能接收子元素
      if (item.isGroup === 0) {
        item.canHaveChildren = false;
      }
      return item;
    });

    console.log('初始化处理后数据');
    console.log(treeData);

    this.setTreeDataWithLastStatus(treeData);

    this.init = true;
    this.setState(
      {
        expandKeys: defaultExpandedKeys,
        selectTreeNode: selectTreeNode,
        loading: false,
      },
      () => {
        if (this.props.initAutoSelect && selectTreeNode) {
          this.props.initAutoSelect(this.dealReturnItem(selectTreeNode), this.dealReturnItem(path));
        }
      },
    );
  }

  //设置选择的内容
  setSelItem(selItemId, cb, keepOriginExpand = false) {
    //如果有选择的值，则展开的键要算
    let selectTreeNode = null;
    //keepOriginExpand 保持原来已经展开的
    let defaultExpandedKeys = keepOriginExpand ? _.cloneDeep(this.state.expandKeys || {}) : {};
    if (selItemId) {
      selectTreeNode = TreeDataHandler.searchTreeNodeByField(
        this.treeDataFull,
        {
          field: 'id',
          value: selItemId,
        },
        'children',
      );

      let path = TreeDataHandler.getNodeDeepPath(
        this.treeDataFull,
        (o) => {
          return o['id'] === selItemId;
        },
        'children',
      );

      if (path.length >= 0) {
        path.forEach((item) => {
          defaultExpandedKeys[item.id] = true;
        });
      }

      cb?.(this.dealReturnItem(path) || []);
    }

    console.log('selectTreeNode', selectTreeNode);
    console.log('defaultExpandedKeys', defaultExpandedKeys);
    this.setState(
      {
        matchTxt: null,
        expandKeys: defaultExpandedKeys,
        selectTreeNode: selectTreeNode,
      },
      () => {
        this.refreshTreeDataAction(this.treeDataFull);
      },
    );
  }

  //刷新数据
  async refreshTreeDataAction(treeData, cb) {
    this.setState({
      loading: true,
    });

    if (!treeData) {
      treeData = await this.getCompleteTreeData();
    }

    let { expandKeys } = this.state;

    //给设置扩展属性
    treeData = TreeDataHandler.recursionDeal(treeData, (item, depth) => {
      //是否展开
      item.collapsed = !expandKeys.hasOwnProperty(item.id);
      //是否能接收子元素
      if (item.isGroup === 0) {
        item.canHaveChildren = false;
      }
      return item;
    });

    console.log('刷新数据');
    console.log(treeData);

    this.setTreeDataWithLastStatus(treeData);
    this.setState({
      loading: false,
    });
    cb?.(treeData);
  }

  //获取完整的树结构数据
  async getCompleteTreeData() {
    let result;

    if (this.props.requestTreeData) {
      result =
        (await this.props.requestTreeData().catch((err) => {
          Modal.error({
            title: '获取目录数据失败',
            content: err?.toString() || '未知原因',
          });
        })) || [];
      //处理字段映射
      result = TreeDataHandler.changeField(result, this.fields, 'new', this.fields.children || 'children');
    } else {
      result = [];
    }

    return result;
  }

  //绘制树节点
  drawTreeItem(item) {
    let { expandKeys, selectTreeNode } = this.state;

    let getArrowIcon = (treeNode) => {
      let icon = null;
      if (!this.config.hideArrow) {
        if (treeNode.isGroup === 1) {
          if (!treeNode.children?.length) {
            icon = this.config.groupArrowCollapsed;
          } else {
            let ifExpand = expandKeys[treeNode.id];
            icon = ifExpand ? this.config.groupArrowExpanded : this.config.groupArrowCollapsed;
          }
        }
      }

      return icon;
    };

    //根据节点类型展示右边的图标
    let getLeftIcon = (treeNode) => {
      let { expandKeys } = this.state;

      let icon = null;

      if (treeNode.url) {
        return (
          <div
            className={this.styles.icon}
            style={{
              backgroundImage: `url(${treeNode.url})`,
              marginRight: '2px',
            }}
          />
        );
      }

      switch (treeNode.isGroup) {
        case 1:
          //目录
          if(this.config.groupLogoFn){
            icon = this.config.groupLogoFn(treeNode, expandKeys[treeNode.id])
          }else{
            icon = expandKeys[treeNode.id] ? (
              <div>{this.config.groupLogoExpanded}</div>
            ) : (
              <div style={treeNode.children?.length ? {} : { opacity: 0.65 }}>{this.config.groupLogoCollapsed}</div>
            );
          }
          break;
        case 0:
          //子项
          icon = this.config.itemLogoFn ? this.config.itemLogoFn(treeNode) : this.config.itemLogo;
          break;
        default:
          break;
      }

      return icon;
    };

    //sortableTree组件导致提前生成matchTitle 会丢失react子元素属性，所以每次渲染重新生成
    let matchTitle = null;
    if (item.matchTitleConfig) {
      let title = item.title;
      matchTitle = (
        <span>
          {title.slice(0, item.matchTitleConfig.currentFindIndex)}
          <span className={this.styles.matchStyle}>
            {title.slice(item.matchTitleConfig.currentFindIndex, item.matchTitleConfig.currentFindIndex + item.matchTitleConfig.matchTxt.length)}
          </span>
          {title.slice(item.matchTitleConfig.currentFindIndex + item.matchTitleConfig.matchTxt.length)}
        </span>
      );
    }

    let customRightView = null;
    if (this.props.customRightAction) {
      //通用右侧自定义，目录和子项都改
      customRightView = this.props.customRightAction?.(this.dealReturnItem(item));
    } else {
      if (item.isGroup === 1 && this.props.customGroupRightAction) {
        //自定义目录的右侧按钮
        customRightView = this.props.customGroupRightAction?.(this.dealReturnItem(item));
      }
      if (item.isGroup !== 1 && this.props.customItemRightAction) {
        //自定义子项的右侧按钮
        // console.log('自定义子项的右侧按钮', item);
        customRightView = this.props.customItemRightAction?.(this.dealReturnItem(item));
      }
    }

    return (
      <div
        className={this.styles.treeItemBox}
        style={selectTreeNode?.id === item.id ? this.styleSet.selectItemStyle : this.styleSet.usualItemStyle}
        onClick={() => {
          if(item?.isGroup === 1 && !this.config.couldSelectGroup){
            //配置了分组不能选择
            return;
          }
          this.setState(
            {
              selectTreeNode: item,
            },
            () => {
              let pathData = TreeDataHandler.getNodeDeepPath(
                this.treeDataFull,
                (o) => {
                  return o['id'] === item.id;
                },
                'children',
              );

              this.props.onClickTreeItem?.(this.dealReturnItem(item), this.dealReturnItem(pathData));
            },
          );
        }}
      >
        <div className={this.styles.itemLeftBox}>
          {getArrowIcon(item)}
          {getLeftIcon(item)}
          {item.isGroup === 1 ? (
            <div className={this.styles.groupName}>
              {this.config.renderGroupName ? (
                this.config.renderGroupName(item, matchTitle)
              ) : (
                <Tooltip mouseEnterDelay={0.5} title={<span style={{ color: '#333' }}>{item.title}</span>} color={'#fff'}>
                  <div className={this.styles.groupNameOneLine}>
                    <span className={this.styles.groupNameText} style={expandKeys[item.id] && item.children?.length ? {} : { opacity: 0.65 }}>
                      {matchTitle || item.title}
                    </span>
                    {this.config.showGroupNum ? (
                      !item.children?.length ? (
                        this.config.showEmptyMark ? (
                          <span className={this.styles.childNumEmptyTag}>0</span>
                        ) : null
                      ) : (
                        <span className={this.styles.childNumTag}>{item.children?.length || 0}</span>
                      )
                    ) : null}
                  </div>
                </Tooltip>
              )}
            </div>
          ) : (
            <div className={this.styles.itemName}>
              {this.config.renderItemName ? (
                this.config.renderItemName(item, matchTitle)
              ) : (
                <Tooltip mouseEnterDelay={0.5} title={<span style={{ color: '#333' }}>{item.title}</span>} color={'#fff'}>
                  <div className={this.styles.nameOneLine}>{matchTitle || item.title}</div>
                </Tooltip>
              )}
            </div>
          )}
        </div>
        <div
          className={this.styles.itemRightBox}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
          }}
        >
          {customRightView}
          {this.getGetItemAddBtnView(item)}
          {this.getGetItemMoreBtnView(item)}
        </div>
      </div>
    );
  }

  //顶部新增按钮
  getTopAddView() {
    if (!this.config.couldAddItem && !this.config.couldAddGroup) {
      return null;
    }

    if (this.config.couldAddItem && this.config.couldAddGroup) {
      //分组和项目都能新增，需要下拉选
      return (
        <Dropdown
          menu={{
            items: [
              {
                key: 'addGroup',
                label: (
                  <Flex align={'center'} gap={5}>
                    {this.config.addGroupIcon}
                    {`新增${this.config.groupName}`}
                  </Flex>
                ),
              },
              {
                key: 'addItem',
                label: (
                  <Flex align={'center'} gap={5}>
                    {this.config.addItemIcon}
                    {`新增${this.config.itemName}`}
                  </Flex>
                ),
              },
            ],
            onClick: ({ item, key }) => {
              switch (key) {
                case 'addGroup':
                  this.dealItemAction(null, {
                    type: 'addGroup',
                  });
                  break;
                case 'addItem':
                  this.dealItemAction(null, {
                    type: 'addItem',
                  });
                  break;
              }
            },
          }}
          placement="bottomLeft"
        >
          <div className={this.styles.addIconBtn}>
            <PlusOutlined />
          </div>
        </Dropdown>
      );
    }

    return (
      <Tooltip title={`新增${this.config.couldAddItem ? this.config.itemName : this.config.groupName}`}>
        <div
          className={this.styles.addIconBtn}
          onClick={() => {
            if (this.config.couldAddItem) {
              this.dealItemAction(null, {
                type: 'addItem',
              });
            } else {
              this.dealItemAction(null, {
                type: 'addGroup',
              });
            }
          }}
        >
          <PlusOutlined />
        </div>
      </Tooltip>
    );
  }

  //栏目中的新增按钮
  getGetItemAddBtnView(currentTreeNode) {
    if (this.config.hideItemAddBtn) {
      return null;
    }

    if (currentTreeNode.isGroup === 0) {
      //项目下不能新增任何内容
      return null;
    }

    if (!this.config.couldAddItem && !this.config.couldAddGroup) {
      //没有任何新增权限
      return null;
    }

    if (this.config.couldAddItem && this.config.couldAddGroup) {
      //分组和项目都能新增，需要下拉选

      let items = [
        {
          key: 'addGroup',
          label: (
            <Flex align={'center'} gap={5}>
              {this.config.addGroupIcon}
              {`新增${this.config.groupName}`}
            </Flex>
          ),
        },
        {
          key: 'addItem',
          label: (
            <Flex align={'center'} gap={5}>
              {this.config.addItemIcon}
              {`新增${this.config.itemName}`}
            </Flex>
          ),
        },
      ];

      if (this.props.diyAddDropdown) {
        items = this.props.diyAddDropdown(currentTreeNode, this.config);
      }

      return (
        <Dropdown
          menu={{
            items: items,
            onClick: ({ item, key }) => {
              switch (key) {
                case 'addGroup':
                  this.dealItemAction(currentTreeNode, {
                    type: 'addGroup',
                  });
                  break;
                case 'addItem':
                  this.dealItemAction(currentTreeNode, {
                    type: 'addItem',
                  });
                  break;
              }
            },
          }}
          placement="bottomLeft"
        >
          <div className={this.styles.actionIconOut}>{this.config.addIcon}</div>
        </Dropdown>
      );
    }

    return (
      <Tooltip title={`新增${this.config.couldAddItem ? this.config.itemName : this.config.groupName}`}>
        <div
          onClick={() => {
            if (this.config.couldAddItem) {
              this.dealItemAction(currentTreeNode, {
                type: 'addItem',
              });
            } else {
              this.dealItemAction(currentTreeNode, {
                type: 'addGroup',
              });
            }
          }}
        >
          <div className={this.styles.actionIconOut}>{this.config.addIcon}</div>
        </div>
      </Tooltip>
    );
  }

  //更多操作的按钮
  getGetItemMoreBtnView(currentTreeNode) {
    if (!this.config.couldEditGroup && !this.config.couldDeleteGroup && currentTreeNode.isGroup === 1) {
      //没有分组的任何操作权限
      return null;
    }
    if (!this.config.couldEditItem && !this.config.couldDeleteItem && currentTreeNode.isGroup === 0) {
      //没有项目的任何操作权限
      return null;
    }

    let items = [];

    if (this.config.customRightActionBefore && this.config.customRightActionBefore.length) {
      this.config.customRightActionBefore.forEach((item, index) => {
        const itemNode = item(this.dealReturnItem(currentTreeNode));
        if (itemNode) {
          items.push({
            key: 'before-' + index,
            label: itemNode,
          });
        }
      });
    }

    if ((this.config.couldEditGroup && currentTreeNode.isGroup === 1) || (this.config.couldEditItem && currentTreeNode.isGroup === 0)) {
      items.push({
        key: 'edit',
        label: (
          <Flex align={'center'} gap={5}>
            {currentTreeNode.isGroup === 1 ? this.config.editGroupName : this.config.editItemName}
          </Flex>
        ),
      });
    }

    if (this.config.couldCloneItem && currentTreeNode.isGroup === 0) {
      items.push({
        key: 'clone',
        label: (
          <Flex align={'center'} gap={5}>
            {this.config.cloneItemName}
          </Flex>
        ),
      });
    }

    if ((this.config.couldDeleteGroup && currentTreeNode.isGroup === 1) || (this.config.couldDeleteItem && currentTreeNode.isGroup === 0)) {
      items.push({
        key: 'delete',
        label: (
          <Flex align={'center'} gap={5} style={{ color: 'red' }}>
            {currentTreeNode.isGroup === 1 ? this.config.deleteGroupName : this.config.deleteItemName}
          </Flex>
        ),
      });
    }

    if (this.config.customRightActionAfter && this.config.customRightActionAfter.length) {
      this.config.customRightActionAfter.forEach((item, index) => {
        const itemNode = item(this.dealReturnItem(currentTreeNode));
        if (itemNode) {
          items.push({
            key: 'after-' + index,
            label: itemNode,
          });
        }
      });
    }

    return (
      <Dropdown
        menu={{
          items: items,
          onClick: ({ item, key }) => {
            switch (key) {
              case 'edit':
                this.dealItemAction(currentTreeNode, {
                  type: 'edit',
                });
                break;
              case 'delete':
                this.dealItemAction(currentTreeNode, {
                  type: 'delete',
                });
                break;
              case 'clone':
                this.cloneItemAction(this.dealReturnItem(currentTreeNode), {
                  type: 'clone',
                });
                break;
            }
          },
        }}
        placement="bottomLeft"
      >
        <div className={this.styles.actionIconOut}>{this.config.moreIcon}</div>
      </Dropdown>
    );
  }

  render() {
    let { treeData, loading, matchTxt, upDate, expandKeys, disableDragAndDrop, selectTreeNode, hasGroup } = this.state;
    return (
      <div className={this.styles.outerBox} style={{ ...this.styleSet.containerStyle }}>
        {loading ? (
          <div className={this.styles.loadingLayer}>
            <Spin size={'large'} />
          </div>
        ) : null}
        {this.config.hideTitle ? null : (
          <div className={this.styles.mainTitleBox}>
            <div className={this.styles.directoryTitle}>{typeof this.props.title === 'function' ? this.props.title(this) : this.props.title}</div>
            {this.getTopAddView()}
          </div>
        )}
        <div className={this.styles.searchBox}>
          <Input
            // size={"small"}
            prefix={<SearchOutlined />}
            allowClear={true}
            placeholder={this.config.placeholderText}
            maxLength={20}
            value={matchTxt}
            onChange={(e) => {
              let value = e.target.value;
              this.findMatchTree(value);
            }}
          />
        </div>
        {this.props.customToolBar ? this.props.customToolBar(this) : null}
        <div className={this.styles.subTitleBox}>
          <Tooltip title={'点击刷新'}>
            <div
              className={this.styles.directoryTitle}
              onClick={() => {
                this.setState(
                  {
                    selectTreeNode: null,
                  },
                  () => {
                    this.refreshTreeDataAction();
                  },
                );
              }}
            >
              {this.config.subTitle}
            </div>
          </Tooltip>
          {hasGroup ? (
            Object.keys(expandKeys)?.length ? (
              <Tooltip title={'全部收起'}>
                <div
                  className={this.styles.closeAllIcon}
                  onClick={() => {
                    this.closeAll();
                  }}
                />
              </Tooltip>
            ) : (
              <Tooltip title={'全部展开'}>
                <div
                  className={this.styles.openAllIcon}
                  onClick={() => {
                    this.openAll();
                  }}
                />
              </Tooltip>
            )
          ) : null}
        </div>
        <div className={this.styles.treeBox}>
          {treeData && treeData.length > 0 ? (
            <SortableTree
              key={'st_' + upDate}
              items={treeData} //数据源
              indentationWidth={this.config.childIndent} //子项距离
              disableSorting={!this?.config?.couldDrag} //禁止拖拽
              disabled={true}
              keepGhostInPlace={false} //拖拽保留原位
              dndContextProps={{}} //覆盖 @dnd-kit 原始 DndContext 属性
              sortableProps={{}} //覆盖 @dnd-kit 原始 useSortable 属性
              pointerSensorOptions={{
                activationConstraint: {
                  distance: 10,
                },
              }}
              onItemsChanged={(newTreeData, reason) => {
                this.dealItemChanged(newTreeData, reason);
              }}
              TreeItemComponent={React.forwardRef((props, ref) => (
                <SimpleTreeItemWrapper
                  {...props}
                  ref={ref}
                  manualDrag={false} //设置仅通过dragHandle抓取
                  showDragHandle={false} //是否显示dragHandle
                >
                  {this.drawTreeItem(props.item)}
                </SimpleTreeItemWrapper>
              ))}
            />
          ) : this.state.matchTxt ? (
            <div className={this.styles.noMatch}>没有匹配"{this.state.matchTxt}"的数据</div>
          ) : (
            <div className={this.styles.noMatch02}>暂无数据</div>
          )}
        </div>
      </div>
    );
  }

  //收起所有
  closeAll() {
    this.setState(
      {
        expandKeys: {},
      },
      () => {
        this.refreshTreeDataAction(this.treeDataFull);
      },
    );
  }

  openAll() {
    let defaultExpandedKeys = {};
    let allNodes = TreeDataHandler.searchTreeNodes(
      this.treeDataFull,
      (item) => {
        return true;
      },
      false,
      'children',
    );

    if (allNodes.length >= 0) {
      allNodes.forEach((item) => {
        defaultExpandedKeys[item.id] = true;
      });
    }

    this.setState(
      {
        expandKeys: defaultExpandedKeys,
      },
      () => {
        this.refreshTreeDataAction(this.treeDataFull);
      },
    );
  }

  //通过关键词匹配节点
  findMatchTree(value) {
    this.setState(
      {
        matchTxt: value,
      },
      () => {
        let filterResult = this.filterTreeData(this.treeDataFull, value);
        this.setState({
          treeData: filterResult.returnTree,
          expandKeys: filterResult.pathKeys,
        });
      },
    );
  }

  //过滤节点
  filterTreeData(oldTree, matchTxt) {
    let pathKeys = []; //哈希数组
    oldTree = JSON.parse(JSON.stringify(oldTree));
    if (!oldTree) {
      return {
        pathKeys: this.state.expandKeys,
        returnTree: oldTree,
      };
    }

    if (!matchTxt) {
      //不再搜索
      let expandedKeys = this.state.expandKeys;
      //如果有选择的值，则展开的键要算
      if (this.state.selectTreeNode) {
        expandedKeys = {};
        let path = TreeDataHandler.getNodeDeepPath(
          oldTree,
          (o) => {
            return o.id === this.state.selectTreeNode.id;
          },
          'children',
        );

        if (path.length >= 0) {
          path.forEach((item) => {
            expandedKeys[item.id] = true;
          });
        }
      }

      //给设置扩展属性
      oldTree = TreeDataHandler.recursionDeal(oldTree, (item) => {
        //是否展开
        item.collapsed = !expandedKeys.hasOwnProperty(item.id);
        return item;
      });

      return {
        pathKeys: expandedKeys,
        returnTree: oldTree,
      };
    }

    matchTxt = _.trim(matchTxt.toLowerCase());

    let find = (treeNode) => {
      if (!treeNode) {
        return null;
      }

      //判断子节点有没有找到
      let childFindArr = [];
      treeNode.children &&
        treeNode.children.forEach((child) => {
          if (find(child)) {
            childFindArr.push(child);
          }
        });

      if (childFindArr.length > 0) {
        //子找到了
        treeNode.children = childFindArr;
        treeNode.collapsed = false;
        pathKeys[treeNode.id] = true;
        return treeNode;
      } else {
        //子没找到
        let currentFindIndex = treeNode.title.toLowerCase().indexOf(matchTxt);
        if (currentFindIndex !== -1) {
          treeNode.matchTitleConfig = {
            currentFindIndex: currentFindIndex,
            matchTxt: matchTxt,
          };
          return treeNode;
        } else {
          return null;
        }
      }
    };

    let newTree = [];
    oldTree.forEach((item) => {
      if (find(item)) {
        newTree.push(item);
      }
    });

    return {
      pathKeys: pathKeys,
      returnTree: newTree,
    };
  }

  //返回数据之前，先处理字段映射
  dealReturnItem(data) {
    let result = TreeDataHandler.changeField(data, this.fieldsReverse, 'new', 'children');
    return result;
  }

  //处理编辑事件
  async dealItemAction(targetTree, reason) {
    switch (reason.type) {
      case 'delete':
        //处理删除事件
        await this.props.onDelete?.(this.dealReturnItem(targetTree));
        await this.refreshTreeDataAction();
        break;
      case 'addGroup':
        //处理新增目录事件
        if (targetTree) {
          let depthMsg = TreeDataHandler.getNodeDeepPath(
            this.treeDataFull,
            (item) => {
              return item.id === targetTree.id;
            },
            'children',
          );
          console.log(depthMsg);
          if (depthMsg?.length >= this.config.maxLevel - 1) {
            Modal.info({
              title: '提示',
              content: '当前层级分组无法再创建子分组',
            });
            return;
          }
        }

        await this.props.onAddGroup?.(targetTree ? this.dealReturnItem(targetTree) : null);
        await this.refreshTreeDataAction();
        break;
      case 'addItem':
        //处理新增项目事件
        await this.props.onAddItem?.(targetTree ? this.dealReturnItem(targetTree) : null);
        await this.refreshTreeDataAction();
        break;
      case 'edit':
        //处理编辑事件
        if (targetTree.isGroup === 1) {
          //编辑目录
          await this.props.onEditGroup?.(this.dealReturnItem(targetTree));
          await this.refreshTreeDataAction();
        } else {
          //编辑子项
          await this.props.onEditItem?.(this.dealReturnItem(targetTree));
          await this.refreshTreeDataAction();
        }

        break;
    }
  }

  //处理树结构变更
  async dealItemChanged(newTreeData, reason) {
    // console.warn("newTreeData",newTreeData);
    // console.warn("reason",reason);

    let { expandKeys } = this.state;

    switch (reason.type) {
      case 'expanded':
        //处理展开
        expandKeys[reason.item.id] = true;
        this.setState({
          expandKeys: expandKeys,
          treeData: newTreeData,
          upDate: this.state.upDate + 1,
        });
        break;
      case 'collapsed':
        //处理收起
        delete expandKeys[reason.item.id];
        this.setState({
          expandKeys: expandKeys,
          treeData: newTreeData,
          upDate: this.state.upDate + 1,
        });
        break;
      case 'dropped':
        //拖拽放入
        if (reason.draggedFromParent?.id === reason.droppedToParent?.id) {
          //父级没有改变，属于排序操作
          let sortChildren = [];
          let parentItem = null;
          if (reason.draggedFromParent) {
            parentItem = this.dealReturnItem(reason.draggedFromParent);

            let newParentItem = TreeDataHandler.searchTreeNodeByField(
              newTreeData,
              {
                field: 'id',
                value: reason.draggedFromParent.id,
              },
              'children',
            );

            sortChildren = this.dealReturnItem(newParentItem.children);
          } else {
            //顶层项目排序
            parentItem = null;
            sortChildren = this.dealReturnItem(newTreeData);
          }

          await this.props.onSort?.(parentItem, sortChildren, reason?.draggedItem);
          await this.refreshTreeDataAction();
        } else {
          //父级发生改变，属于改变层级
          let childItem = reason.draggedItem;
          let parentItem = null;
          let sortChildren = [];
          if (reason.droppedToParent) {
            if (reason.droppedToParent.depth >= this.config.maxLevel - 2 && childItem.isGroup === 1) {
              Modal.info({
                title: '提示',
                content: '当前层级分组无法接收子分组',
              });
              return;
            }

            parentItem = this.dealReturnItem(reason.droppedToParent);
            let newParentItem = TreeDataHandler.searchTreeNodeByField(
              newTreeData,
              {
                field: 'id',
                value: reason.droppedToParent.id,
              },
              'children',
            );

            sortChildren = this.dealReturnItem(newParentItem.children);
          } else {
            sortChildren = this.dealReturnItem(newTreeData);
          }

          await this.props.onChangeGroup?.(parentItem, this.dealReturnItem(childItem), sortChildren);
          await this.refreshTreeDataAction();
        }
        break;
    }
  }

  async cloneItemAction(newTreeData, reason) {
    await this.props.onCloneItem(newTreeData, reason);
  }
}
